module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page page-lesbevoegdheid",
    attrs: {
      "id": "page-lesbevoegdheid"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container list-select"
  }, [_c('h1', [_vm._v("HET HEBBEN VAN EEN LESBEVOEGDHEID VERGROOT JOUW MOGELIJKHEDEN OM ALS HYBRIDE DOCENT AAN DE SLAG TE GAAN")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "list-select__item row",
    class: {
      'list-select__item--selected': _vm.userProfile.bevoegdheid === true
    },
    on: {
      "click": function($event) {
        _vm.setLesbevoegdheid(true)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "list-select__item row",
    class: {
      'list-select__item--selected': _vm.userProfile.bevoegdheid === false
    },
    on: {
      "click": function($event) {
        _vm.setLesbevoegdheid(false)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), (_vm.bevoegdheidEntered) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.submitBevoegdheid()
      }
    }
  }, [_vm._v("Volgende")])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__icon-wrapper"
  }, [_c('i', {
    staticClass: "fa fa-university",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10-sm list-select__title"
  }, [_vm._v("Ben je in het bezit van een lesbevoegdheid?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm list-select__item-marker-column"
  }, [_c('div', {
    staticClass: "list-select__item-marker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-10-sm list-select__item-text"
  }, [_c('p', [_vm._v("Ja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm list-select__item-marker-column"
  }, [_c('div', {
    staticClass: "list-select__item-marker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-10-sm list-select__item-text"
  }, [_c('p', [_vm._v("Nee")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e81812c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-lesbevoegdheid.vue
// module id = 152
// module chunks = 0